import { defineStore } from "pinia";
import { useLocalStorage } from "@vueuse/core";

const defaultState = {
  basket: {
    id: "",
    items: [],
  },
  centers: {},
  currentBookingSlot: null,
  currentCenter: {},
  currentDuration: null,
  currentParticipant: null,
  currentService: {},
  currentServiceVariants: [],
  currentShopifyVariant: {},
  currentStep: 0,
  journeyType: "",
  serviceFamily: null,
  services: {},
  user: null,
  zenotiReservations: [],
  zenotiVariantService: {},
};

export const useBookingStore = defineStore("booking", {
  state: () => {
    if (new URL(window.location.href).searchParams.get("productPage")) {
      return defaultState;
    }
    return useLocalStorage("booking-storage", defaultState);
  },
  getters: {
    step: (state) => {
      return state.currentStep;
    },
    type: (state) => {
      return state.journeyType;
    },
    center: (state) => {
      return state.currentCenter;
    },
    service: (state) => {
      return state.currentService;
    },
    zenotiService: (state) => {
      return state.zenotiVariantService;
    },
    bookingSlot: (state) => {
      return state.currentBookingSlot;
    },
    allCenters: (state) => {
      return state.centers;
    },
    allServices: (state) => {
      return state.services;
    },
    serviceVariants: (state) => {
      return state.currentServiceVariants;
    },
    currentUser: (state) => {
      return state.user;
    },
    reservations: (state) => {
      return state.zenotiReservations;
    },
    shopifyVariant: (state) => {
      return state.currentShopifyVariant;
    },
  },
  actions: {
    addItemToBasket() {
      console.log("add to basket"); // eslint-disable-line
    },
    removeItemFromBasket() {
      console.log("remove from basket"); // eslint-disable-line
    },
    incrementItemCount() {
      console.log("increment item count"); // eslint-disable-line
    },
    decrementItemCount() {
      console.log("decrement item count"); // eslint-disable-line
    },
    moveToNextStep() {
      if (this.currentStep <= 1) {
        // then increment
        this.currentStep++;
      }
      return this.currentStep;
    },
    moveToPreviousStep() {
      if (this.currentStep > 0) {
        // then decrement
        this.currentStep--;
      }
      return this.currentStep;
    },
    moveToStep(step) {
      if (this.currentStep > 0) {
        this.currentStep = step;
      }
      return this.currentStep;
    },
    updateJourneyType(newType) {
      this.journeyType = newType;
    },
    updateCurrentCenter(newCenter) {
      this.currentCenter = newCenter;
    },
    updateCurrentService(newService) {
      this.currentService = newService;
    },
    updateZenotiVariantService(newVariantService) {
      this.zenotiVariantService = newVariantService;
    },
    updateCurrentBookingSlot(newSlot) {
      this.currentBookingSlot = newSlot;
    },
    updateCenters(newCenters) {
      this.centers = newCenters;
    },
    updateServices(newServices) {
      this.services = newServices;
    },
    updateCurrentServiceVariants(newVariants) {
      this.currentServiceVariants = newVariants;
    },
    updateServiceFamily(newFamily) {
      this.serviceFamily = newFamily;
    },
    updateUser(newUser) {
      this.user = newUser;
    },
    updateZenotiReservations(newReservations) {
      this.zenotiReservations = newReservations;
    },
    updateCurrentShopifyVariant(newVariant) {
      this.currentShopifyVariant = newVariant;
    },
    resetStore() {
      this.basket = {
        id: "",
        items: [],
      };
      this.centers = {};
      this.currentBookingSlot = null;
      this.currentCenter = {};
      this.currentDuration = null;
      this.currentParticipant = null;
      this.currentService = {};
      this.currentServiceVariants = [];
      this.currentShopifyVariant = {};
      this.currentStep = 0;
      this.journeyType = "";
      this.serviceFamily = null;
      this.services = {};
      this.user = {};
      this.zenotiReservations = [];
      this.zenotiVariantService = {};
    },
  },
});
